export default {
      id: "ic_down-usage",
      viewBox: "0 0 11 6",
      url: "/" + "images/icons.3.109.2.svg#ic_down-usage",
      toString: function () {
        return this.url;
      }
    }